var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40606 12.4715C2.55158 12.5394 2.72077 12.4827 2.80576 12.3363L6.67295 5.63313C6.73557 5.52464 6.73936 5.38765 6.6827 5.27574C6.62605 5.16347 6.51779 5.09377 6.4004 5.09377H3.81944L4.77931 0.938088C4.81803 0.770205 4.73965 0.596814 4.59395 0.528494C4.44919 0.460525 4.27892 0.517502 4.19425 0.663752L0.327065 7.36688C0.264438 7.47537 0.260656 7.61236 0.317311 7.72427C0.373965 7.83654 0.482225 7.90624 0.599615 7.90624H3.18058L2.2207 12.0619C2.18198 12.2298 2.26034 12.4032 2.40606 12.4715Z",
    fill: "#155EEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltBlue);
export default __webpack_public_path__ + "static/media/bolt-blue.90fdafdb829d78fcb8cc27a55e6b3a0f.svg";
export { ForwardRef as ReactComponent };